// CSS stays in the main bundle so cascade order is unchanged; only the JS is lazy loaded.
import "@brivity/ai-components/dist/index.css";
import { Suspense, useEffect } from "react";
import PropTypes from "prop-types";
import { getAiToken } from "@shared/externalApi";
import { useAiAssistApiUrl, useMcpAppSandboxUrl, useTheme } from "../../reducers/layoutReducer/selectors";
import { lazyAiComponent, loadAiComponents } from "./lazyAiComponent";

const AiComponentsProvider = lazyAiComponent("AiComponentsProvider");

function AiProvider({ children }) {
  const apiUrl = useAiAssistApiUrl();
  const mcpAppSandboxUrl = useMcpAppSandboxUrl();
  const theme = useTheme();

  useEffect(() => {
    loadAiComponents()
      .then(({ AI_COMPONENTS_VERSION }) => {
        window.localStorage.setItem("ai-components-version", AI_COMPONENTS_VERSION);
      })
      .catch(() => undefined);
  }, []);

  return (
    <Suspense fallback={null}>
      <AiComponentsProvider
        fetchAuthToken={() => getAiToken().then(({ crmAccessToken }) => crmAccessToken)}
        fetchMessagingUserToken={() => getAiToken().then(({ token }) => token)}
        apiUrl={apiUrl}
        graphApiUrl="/api/brivity/graph"
        theme={theme.name === "place-theme" ? "ai-place" : "ai-brivity"}
        mcpAppSandboxUrl={mcpAppSandboxUrl}
      >
        {children}
      </AiComponentsProvider>
    </Suspense>
  );
}

AiProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AiProvider;
